// extracted by mini-css-extract-plugin
export default {"header":"ViewContact_header__I6iYc","close":"ViewContact_close__OzK0Y","menu":"ViewContact_menu__MWfh9","body":"ViewContact_body__tq-kw"};